import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import Modal from 'commons-general/components/Modal/Modal.jsx';

import ModalService from 'commons-general/services/ModalService/ModalService.js';
import 'commons-general/components/WhiteModal/WhiteModal.scss';

class WhiteModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.modal = ModalService.get(this.props.name);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.modal.close();
    }

    render() {
        const {
            children,
            name,
            contentLabel,
            isScrollable,
            isClosable,
            dataTestPrefix,
            className,
            backgroundImage,
            onModalPropertiesChange,
        } = this.props;

        const whiteStyle = backgroundImage ? { overlay: { backgroundImage: `url(${backgroundImage})` } } : {};

        const overlayClassName = backgroundImage ? 'sr-modal-overlay--login' : 'sr-modal-overlay--white';

        const classNames = ['sr-modal--white'];

        if (className) {
            classNames.push(className);
        }
        return (
            <Modal
                name={name}
                contentLabel={contentLabel}
                className={classNames.join(' ')}
                overlayClassName={overlayClassName}
                shouldCloseOnOverlayClick={false}
                isScrollable={isScrollable}
                style={whiteStyle}
                onModalPropertiesChange={onModalPropertiesChange}
            >
                {isClosable && (
                    <button
                        className="sr-modal--white-close is-uppercase"
                        onClick={this.closeModal}
                        data-test={dataTestPrefix ? `${dataTestPrefix}.modal-close-button` : 'modal-close-button'}
                    >
                        {LocaleService.t('COMMONS_GENERAL.MODAL.CLOSE')} <icon className="icon-X-rouge" />
                    </button>
                )}

                {/* Here we clone children add pass them new props registered into ModalInstance */
                React.Children.map(children, (child) => React.cloneElement(child))}
            </Modal>
        );
    }
}

WhiteModal.defaultProps = {
    isScrollable: false,
    isClosable: true,
    dataTestPrefix: '',
    className: '',
    backgroundImage: '',
};

WhiteModal.propTypes = {
    children: PropTypes.node,
    name: PropTypes.string.isRequired,
    contentLabel: PropTypes.string.isRequired,
    isScrollable: PropTypes.bool,
    isClosable: PropTypes.bool,
    dataTestPrefix: PropTypes.string,
    className: PropTypes.string,
    backgroundImage: PropTypes.string,
    onModalPropertiesChange: PropTypes.func,
};

WhiteModal.displayName = 'WhiteModal';

export default WhiteModal;
